import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  const lastUpdated = 'May 27, 2026';

  return (
    <div className="min-h-screen bg-black text-gray-300">
      <div className="bg-gradient-to-b from-secondary-400/10 to-transparent pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/" className="text-primary-400 hover:text-primary-300 text-sm mb-4 inline-flex items-center gap-2">
            ← Back to Home
          </Link>
          <h1 className="text-4xl md:text-5xl font-gaming font-bold text-white mt-4">Terms of Service</h1>
          <p className="text-gray-500 mt-4">Last updated: {lastUpdated}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 pb-24">
        <div className="prose prose-invert prose-lg max-w-none space-y-10">

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p>By downloading, installing, or using any mobile game or application published by Riven Byte Studios ("we," "us," "our"), you agree to be bound by these Terms of Service. If you do not agree, do not use our Apps.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. License to Use</h2>
            <p>We grant you a limited, non-exclusive, non-transferable, revocable license to download and use our Apps for your personal, non-commercial entertainment purposes, subject to these Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Restrictions</h2>
            <p>You agree not to:</p>
            <ul className="mt-3 space-y-2 text-sm">
              <li>Modify, reverse engineer, decompile, or disassemble any part of our Apps</li>
              <li>Use our Apps for any commercial purpose without written permission</li>
              <li>Attempt to circumvent any security features or advertising systems</li>
              <li>Use automated tools, bots, or scrapers to interact with our Apps</li>
              <li>Distribute, sublicense, or sell copies of our Apps outside official app stores</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
            <p>All content in our Apps — including but not limited to game designs, graphics, animations, sounds, text, and code — is owned by Riven Byte Studios or our licensors and is protected by copyright and intellectual property laws. Some of our games are built upon open-source foundations used under permissive licenses (MIT, Apache 2.0, BSD), which we acknowledge and comply with.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Advertising</h2>
            <p>Our free Apps contain advertisements provided by third-party ad networks (Google AdMob). By using our Apps, you acknowledge and consent to the display of advertisements. Ad content is provided by third parties and we are not responsible for the content of such advertisements.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Disclaimer of Warranties</h2>
            <p>Our Apps are provided "as is" and "as available" without any warranties of any kind, either express or implied. We do not guarantee that our Apps will be uninterrupted, error-free, or free of harmful components.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, Riven Byte Studios shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our Apps.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Termination</h2>
            <p>We reserve the right to terminate or suspend your access to our Apps at any time, without notice, for any reason, including breach of these Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Changes to Terms</h2>
            <p>We may update these Terms from time to time. Continued use of our Apps after changes constitutes acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
            <p>These Terms are governed by the laws of the United Republic of Tanzania. Any disputes arising from these Terms shall be resolved in the courts of Dar es Salaam, Tanzania.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Contact</h2>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10">
              <p className="text-white font-semibold">Riven Byte Studios</p>
              <p className="text-sm mt-2">Email: <a href="mailto:hello@rivenbyte.com" className="text-primary-400">hello@rivenbyte.com</a></p>
              <p className="text-sm">Location: Dar es Salaam, Tanzania</p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsPage;
